/*
 * Module for the Service Purhase Time Blocks tab
*/

rs.module("content/participant/member/servicepurchase/timeblocks",

    [],

    function () {

        //
        // Initialize
        //
        function initialize(jsSelectors, timeBlockGrid, backendUrls, editAllowed, penaltyEndDate) {

            var _executeSelectionChanged = false;

            $.js(jsSelectors.addLink, { required: false }).click(function () {

                timeBlockGrid.selectedValues = null;
                loadTimeBlockDetail(null);
            });

            timeBlockGrid.selectionChanged(function (values, rows) {

                // This handler fires when the grid is first rendered, but we don't want it to in our case
                // _executeSelectionChanged will be false the first time it runs, after that this will fire every time a row is clicked
                if (_executeSelectionChanged && values.length > 0) {

                    loadTimeBlockDetail(values[0]);
                }

                _executeSelectionChanged = true;
            });

            function loadTimeBlockDetail(timeBlockKey) {

                $.get(
                    {
                        url: backendUrls.loadTimeBlock,
                        data: {
                            timeBlockKey: timeBlockKey,
                            editAllowed: editAllowed,
                            penaltyEndDate: penaltyEndDate

                        },
                        clearEventBanner: true

                    }).done(function (result) {
                        $.js(jsSelectors.timeBlockForm).html(result);
                    });
            }
        }

        // Exported public API
        var exports = {
            initialize: initialize
        };

        return exports;
    }
);